import { render, staticRenderFns } from "./NewCampaignCard.vue?vue&type=template&id=624b0e11&"
import script from "./NewCampaignCard.vue?vue&type=script&lang=ts&"
export * from "./NewCampaignCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports